const E1 = {
  us: {
    default: 13024,
    mrm: 13024,
  },
  ca: {
    default: 13095,
    mrm: 13095,
  },
  au: {
    default: 105757,
    mrm: 105757,
    offer: 20542,
  },
  gb: {
    default: 13080,
    mrm: 13080,
  },
  mx: {
    default: 14498,
    mrm: 14498,
  },
  sg: {
    default: 105793,
    mrm: 12618,
  },
  fr: {
    default: 13343,
    mrm: 13343,
  },
  de: {
    default: 16899,
    mrm: 16899,
  },
  hk: {
    default: 14341,
    mrm: 14341,
  },
  it: {
    default: 14348,
    mrm: 14348,
  },
  es: {
    default: 14352,
    mrm: 14352,
  },
  nl: {
    default: 14884,
    mrm: 14884,
  },
  jp: {
    default: 18118,
    mrm: 18118,
  },
  ar: {
    default: 115086,
    mrm: 115086,
  },
};
const E2 = {
  us: {
    default: [13024, 104677, 104678, 104679, 105435, 105436, 105437],
    mrm: 13024,
  },
  ca: {
    default: 13095,
    mrm: 13095,
  },
  au: {
    default: 105757,
    mrm: 105757,
    offer: 20542,
  },
  gb: {
    default: 18415,
    mrm: 18415,
  },
  mx: {
    default: 14498,
    mrm: 14498,
  },
  sg: {
    default: 105793,
    mrm: 12618,
  },
  fr: {
    default: 18438,
    mrm: 18438,
  },
  de: {
    default: 18437,
    mrm: 18437,
  },
  hk: {
    default: 14341,
    mrm: 14341,
  },
  it: {
    default: 18416,
    mrm: 18416,
  },
  es: {
    default: 18441,
    mrm: 18441,
  },
  nl: {
    default: 18439,
    mrm: 18439,
  },
  jp: {
    default: 18118,
    mrm: 18118,
  },
  ar: {
    default: 115086,
    mrm: 115086,
  },
};
const E3 = {
  us: {
    default: [13024, 119838, 119899, 119900, 117747, 126569, 126570, 126571],
    mrm: 13024,
  },
  ca: {
    default: 13095,
    mrm: 13095,
  },
  au: {
    default: 105757,
    mrm: 105757,
    offer: 20542,
  },
  gb: {
    default: 18415,
    mrm: 18415,
  },
  mx: {
    default: 14498,
    mrm: 14498,
  },
  sg: {
    default: 105793,
    mrm: 12618,
  },
  fr: {
    default: 18438,
    mrm: 18438,
  },
  de: {
    default: 18437,
    mrm: 18437,
  },
  hk: {
    default: 14341,
    mrm: 14341,
  },
  it: {
    default: 18416,
    mrm: 18416,
  },
  es: {
    default: 18441,
    mrm: 18441,
  },
  nl: {
    default: 18439,
    mrm: 18439,
  },
  jp: {
    default: 18118,
    mrm: 18118,
  },
  ar: {
    default: 115086,
    mrm: 115086,
  },
};

function getMleListId(countryCd, env = 'E3') {
  let mleListId;

  if (env === 'E1') {
    mleListId = E1[countryCd.toLowerCase()];
  } else if (env === 'E2') {
    mleListId = E2[countryCd.toLowerCase()];
  } else {
    mleListId = E3[countryCd.toLowerCase()];
  }
  return mleListId.default;
}

export default getMleListId;
